const CANTIDAD_DIGITOS_CBU = 22;
const PREFIJO_CVU = "000";

const normalizarClaveBancaria = (vchClave: string): string => vchClave.replace(/\s/g, "");

const validarDigitoVerificador = (
    vchBloque: string,
    intDigitoVerificador: number,
    arrPonderadores: readonly number[],
): boolean => {
    const intSuma = [...vchBloque].reduce(
        (intAcumulado, vchDigito, intIndice) =>
            intAcumulado + Number(vchDigito) * arrPonderadores[intIndice],
        0,
    );
    const intDigitoEsperado = (10 - (intSuma % 10)) % 10;

    return intDigitoVerificador === intDigitoEsperado;
};

export const esCVU = (vchClave: string | null | undefined): boolean => {
    const vchClaveNormalizada = normalizarClaveBancaria(String(vchClave ?? ""));

    return /^\d{22}$/.test(vchClaveNormalizada) && vchClaveNormalizada.startsWith(PREFIJO_CVU);
};

export const validarCBU = (vchClave: string | null | undefined): boolean => {
    const vchCbu = normalizarClaveBancaria(String(vchClave ?? ""));

    if (!new RegExp(`^\\d{${CANTIDAD_DIGITOS_CBU}}$`).test(vchCbu) || esCVU(vchCbu)) {
        return false;
    }

    const bitPrimerBloqueValido = validarDigitoVerificador(
        vchCbu.slice(0, 7),
        Number(vchCbu[7]),
        [7, 1, 3, 9, 7, 1, 3],
    );
    const bitSegundoBloqueValido = validarDigitoVerificador(
        vchCbu.slice(8, 21),
        Number(vchCbu[21]),
        [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3],
    );

    return bitPrimerBloqueValido && bitSegundoBloqueValido;
};
